import React, { useEffect, useState, useRef } from "react";
import { Form } from "../../../../api/form";
import {
  Divider,
  Segment,
  Tab,
  TabPane,
  Header,
  Grid,
  GridColumn,
  Checkbox,
  Button,
  GridRow,
  Icon,
  Loader,
  Dimmer,
} from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts/LanguageContext";
// import { WaterKPIsDashBoard } from "../WaterKPIsDashboard/WaterKPIsDashBoard";
import { useSite } from "../../../../contexts";
import { airEmissionsCodes } from "../../../../utils/codes";
import { energyCodes } from "../../../../utils/dataAndFormulas/energyForms";
import { effluentCodes } from "../../../../utils/dataAndFormulas/effluentForms";
import { waterCodes } from "../../../../utils/dataAndFormulas/waterForms";
import { wasteCodes } from "../../../../utils/dataAndFormulas/wasteForms";
import { fuelsCodes } from "../../../../utils/dataAndFormulas/fuelsForms";
import { socialCodes } from "../../../../utils/dataAndFormulas/socialForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { airemissionsCodes } from "../../../../utils/dataAndFormulas/airemissionsForms";
import "./ListConfigForms.scss";
import SearchIcon from "../../../../assets/svg/search.svg";

const permissionController = new Permission();
const formController = new Form();

export function ListConfigForms(props) {
  const { siteSelected } = props;

  const { pathname } = useLocation();
  const {
    user: { role, site, company },
    accessToken,
  } = useAuth();

  const [siteConfigFormSelected, setSiteConfigFormSelected] = useState(null);

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  const [permissionActive, setPermissionsActive] = useState([]);

  const [companySelected, setCompanySelected] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        if (siteSelected) {
          setSiteConfigFormSelected(siteSelected);
        }
      } catch (error) {
        console.error(error);
        setSiteConfigFormSelected(null);
      }
    })();
  }, [siteSelected]);

  useEffect(() => {
    (async () => {
      try {
        if (company) {
          setCompanySelected(company);
        }
      } catch (error) {
        console.error(error);
        setCompanySelected(null);
      }
    })();
  }, [company]);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsActive(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsActive([]);
      }
    })();
  }, [role]);

  const panes = [
    {
      menuItem: { key: "social", icon: "users", content: "Social" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="social"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_sources"}
          />
        </TabPane>
      ),
    },
    {
      menuItem: { key: "energia", icon: "lightning", content: "Energía" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="energy"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_energy_sources"}
          />
        </TabPane>
      ),
    },
    {
      menuItem: { key: "agua", icon: "tint", content: "Agua" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="water"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_water_sources"}
          />
        </TabPane>
      ),
    },
    {
      menuItem: { key: "efluentes", icon: "filter", content: "Efluentes" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="effluent"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_sources"}
          />
        </TabPane>
      ),
    },
    {
      menuItem: { key: "combustibles", icon: "fire", content: "Combustibles" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="fuels"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_sources"}
          />
        </TabPane>
      ),
    },
    {
      menuItem: { key: "residuos", icon: "trash alternate", content: "Residuos" },
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="waste"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_sources"}
          />
        </TabPane>
      ),
    },
    {/*
      menuItem: "Emision al aire",
      render: () => (
        <TabPane attached={false}>
          <FormularioDinamico
            nombreFormulario="airEmissions"
            t={t}
            siteSelected={siteConfigFormSelected}
            textForm={"content_sources"}
          />
        </TabPane>
      ),
    },*/}
  ];

  return (
    <div className="list-config-forms">
      <Tab
        menu={{ borderless: true, attached: false, tabular: false }}
        panes={panes}
      />
    </div>
  );
}

const FormularioDinamico = ({
  nombreFormulario,
  t,
  siteSelected,
  textForm,
}) => {
  const [configuracion, setConfiguracion] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  // Traba sincrónica contra doble-submit: un doble click puede disparar
  // handleSaveChanges dos veces antes de que React repinte el botón
  // deshabilitado — un ref se actualiza al instante, sin ese retraso.
  const submittingRef = useRef(false);
  // Snapshot de los campos tal como vinieron del servidor — al guardar,
  // se compara contra esto para mandar solo los campos que el usuario
  // realmente tocó (togglear 'active' de otro campo no debe pisar cambios
  // que haya guardado otro usuario/pestaña mientras tanto).
  const originalFieldsRef = useRef([]);

  useEffect(() => {
    setSearchTerm("");
  }, [configuracion]);

  const {
    accessToken,
    user: { role },
  } = useAuth();

  const determineKeys = (a) => {
    switch (a) {
      case "social":
        return socialCodes;
      case "energy":
        return energyCodes;
      case "effluent":
        return effluentCodes;
      case "water":
        return waterCodes;
      case "waste":
        return wasteCodes;
      case "fuels":
        return fuelsCodes;
      case "airEmissions":
        return airemissionsCodes;
      default:
        return null;
    }
  };

  const listFields = (nombreFormulario, array) => {
    const a = determineKeys(nombreFormulario);
    const result = [];
    for (const i in a) result.push(i);
    const list = result.map((i) => {
      const obj = array.find((item) => item.name === i); // Busca el objeto con el nombre especificado
      return {
        name: i,
        description: i,
        active: obj ? obj.active : false,
        unit: obj ? obj.unit : undefined, // Conservar la unidad si existe
        code: obj ? obj.code : undefined,
        standardized_coefficient: obj ? obj.standardized_coefficient : undefined
      };
    });
    return list;
  };

  useEffect(() => {
    // Cargar la configuración del formulario desde la API utilizando el nombre del formulario
    if (
      siteSelected &&
      siteSelected !== 0 &&
      siteSelected !== "undefined" &&
      siteSelected !== undefined
    ) {
      setLoading(true);
      formController
        .getFormsBySite(accessToken, siteSelected, nombreFormulario)
        .then((response) => {
          if (response.length > 0) {
            setIsUpdate(true);
            if (response[0].fields && response[0].fields.length === 0) {
              response[0].fields = listFields(nombreFormulario, []);
            } else {
              response[0].fields = listFields(
                nombreFormulario,
                response[0].fields
              );
            }
            originalFieldsRef.current = response[0].fields.map((f) => ({ ...f }));
            setConfiguracion(response[0]);
          } else {
            setIsUpdate(false);
            const fields = listFields(nombreFormulario, []);
            originalFieldsRef.current = fields.map((f) => ({ ...f }));
            setConfiguracion({
              module: nombreFormulario,
              fields,
              site: siteSelected,
            });
          }
        })
        .catch((error) =>
          console.error("Error al cargar la configuración:", error)
        )
        .finally(() => setLoading(false));
    }
  }, [nombreFormulario, siteSelected]);

  // Función para manejar el cambio en los campos
  const handleInputChange = (na, checked) => {
    setConfiguracion((prevJsonData) => {
      const updatedFields = configuracion.fields.map((field) => {
        if (field.name === na) {
          return { ...field, active: checked }; // Modificar 'active' según el checkbox
        }
        return field;
      });

      return { ...prevJsonData, fields: updatedFields };
    });

    setSelectedItems((prevSelected) => {
      if (checked) {
        // Si el checkbox está marcado, agregar el item a la lista de seleccionados
        return [...prevSelected, na];
      } else {
        // Si el checkbox no está marcado, eliminar el item de la lista de seleccionados
        return prevSelected.filter((selected) => selected !== na);
      }
    });
  };

  // Función para enviar los cambios de configuración al backend
  const handleSaveChanges = () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setLoading(true);
    if (isUpdate) {
      // Solo mandamos los campos cuyo 'active' realmente cambió respecto a lo
      // último cargado del servidor — así el guardado atómico del servidor
      // no pisa cambios que otro usuario/pestaña haya guardado mientras tanto
      // en otros campos.
      const changes = configuracion.fields.filter((f) => {
        const orig = originalFieldsRef.current.find((o) => o.name === f.name);
        return !orig || orig.active !== f.active;
      });

      if (changes.length === 0) {
        setLoading(false);
        submittingRef.current = false;
        toast.info("No hay cambios para guardar.");
        return;
      }

      formController
        .updateFieldsActive(accessToken, configuracion._id, changes)
        .then((response) => {
          if (response.code === 200) {
            toast.success("Configuración actualizada correctamente!!");
            const updatedFields = listFields(nombreFormulario, response.dataStore.fields);
            originalFieldsRef.current = updatedFields.map((f) => ({ ...f }));
            setConfiguracion((prev) => ({ ...prev, fields: updatedFields }));
          } else {
            toast.error(`${response.msg}`);
          }
        })
        .catch((error) => {
          console.error("Error al guardar la configuración:", error);
          toast.error(`${error.msg}`);
        })
        .finally(() => {
          setLoading(false);
          submittingRef.current = false;
        });
    } else {
      formController
        .createForm(accessToken, configuracion)
        .then((response) => {
          if (response.code === 200) {
            toast.success("Configuración guardada correctamente!");
            // Ya quedó creado: de acá en más, "Guardar" debe actualizar este
            // mismo documento en vez de intentar crear otro — si no, la
            // próxima vez que se guarde en la misma visita chocaría contra
            // el índice único {module, site} y se perderían esos cambios.
            setIsUpdate(true);
            originalFieldsRef.current = configuracion.fields.map((f) => ({ ...f }));
            setConfiguracion((prev) => ({ ...prev, _id: response.dataStore._id }));
          } else {
            toast.error(`${response.msg}`);
          }
        })
        .catch((error) => {
          console.error("Error al guardar la configuración:", error);
          toast.error(`${error.msg}`);
        })
        .finally(() => {
          setLoading(false);
          submittingRef.current = false;
        });
    }
  };

  if (!configuracion) return (
    <Dimmer active inverted>
      <Loader inverted>Cargando...</Loader>
    </Dimmer>
  );

  // Filtrar los datos según el término de búsqueda
  const filteredData = configuracion.fields.filter((item) =>
    t(item.description).toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ position: "relative" }}>
      <Dimmer active={loading} inverted>
        <Loader inverted />
      </Dimmer>
      <div className="config-form-header">
        <h3 className="config-form-title">
          Seleccione todas según corresponda
        </h3>
        <div className="config-form-header-actions">
          <div className="config-form-search">
            <img src={SearchIcon} alt="search" className="config-search-icon" />
            <input
              type="text"
              placeholder="Buscar por nombre..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Button className="config-save-btn" onClick={handleSaveChanges} loading={loading} disabled={loading}>
            Guardar
          </Button>
        </div>
      </div>
      {/* Contenedor de elementos */}
      <Grid columns={2} stackable className="config-items-grid">
        {filteredData.map((campo, index) => {
          if (index % 2 === 0) {
            const nextCampo = filteredData[index + 1];
            return (
              <GridRow key={index}>
                <GridColumn mobile={16} tablet={8} computer={8}>
                  <div className="config-item-pill">
                    <Checkbox
                      toggle
                      name={campo.name}
                      checked={campo.active}
                      onChange={(e, { checked }) => {
                        handleInputChange(campo.name, checked);
                      }}
                    />
                    <label>{t(campo.description)}</label>
                  </div>
                </GridColumn>
                {nextCampo && (
                  <GridColumn mobile={16} tablet={8} computer={8}>
                    <div className="config-item-pill">
                      <Checkbox
                        toggle
                        name={nextCampo.name}
                        checked={nextCampo.active}
                        onChange={(e, { checked }) => {
                          handleInputChange(nextCampo.name, checked);
                        }}
                      />
                      <label>{t(nextCampo.description)}</label>
                    </div>
                  </GridColumn>
                )}
              </GridRow>
            );
          }
          return null;
        })}
      </Grid>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default FormularioDinamico;
